import React, { createContext, useContext } from "react";
import { useAuth } from "./AuthContext";

interface AuthenticatedContextType {
  userId: string;
}

const AuthenticatedContext = createContext<
  AuthenticatedContextType | undefined
>(undefined);

export function AuthenticatedProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuth();

  if (!user) {
    throw new Error(
      "AuthenticatedProvider must be used within an authenticated context",
    );
  }

  return (
    <AuthenticatedContext.Provider value={{ userId: user.uid }}>
      {children}
    </AuthenticatedContext.Provider>
  );
}

export function useAuthenticated() {
  const context = useContext(AuthenticatedContext);
  if (context === undefined) {
    throw new Error(
      "useAuthenticated must be used within an AuthenticatedProvider",
    );
  }
  return context;
}
